export const convertRegisterStatusForTable = (status) => {
  if (status === 'FAILED') return 'Failed'
  if (status === 'CANCELED') return 'Failed'
  if (status === 'PENDING') return 'Pending'
  if (status === 'SUCCESS') return 'Success';

  return '';
}